import { useForm } from '@inertiajs/inertia-react';
import useCForm from 'app/components/hooks/useCForm';
import Layout from 'app/components/Layouts/Layout'
import { ProjectType } from 'app/components/Types/ProjectType';
import { TaskType } from 'app/components/Types/TaskType';
import { TrackingType } from 'app/components/Types/TrackingType';
import { UserType } from 'app/components/Types/UserType';
import DateTimeInput from 'app/fragments/Forms/DateTimeInput';
import Form from 'app/fragments/Forms/Form';
import { SearchCard } from 'app/fragments/Forms/Search';
import SearchMultiple from 'app/fragments/Forms/SearchMultiple';
import Select from 'app/fragments/Forms/Select';
import Submit from 'app/fragments/Forms/Submit';
import TextField from 'app/fragments/Forms/TextField';
import moment from 'moment';
import React from 'react'
import route from 'ziggy-js';

interface Props {
    tracking: TrackingType
    tasks: Array<TaskType>
}

function Edit(props: Props) {
    const { tracking, tasks } = props

    const form = useCForm({
        id: tracking.id,
        task: [tracking.task.id] as any,
        user: [tracking.user.id] as any,
        created_at: moment(tracking.created_at).format("DD. MM. YYYY HH:mm"),
        end_date: moment(tracking.end_date).format("DD. MM. YYYY HH:mm")
    });
    const { data, post, transform } = form;

    const submit = (e) => {
        e.preventDefault();
        transform(({ task, user, ...d }) => ({ ...d, user_id: user[0], task_id: task[0] }));

        post(route('trackings.update', { tracking: tracking.id }), {preserveState: false });
    }

    return (
        <Layout>
            <div className='flex items-center justify-center min-h-noHeader w-full'>
                <Form className='w-300px' form={form} onSubmit={submit}>
                    {/* <TextField name="id" label={"ID"} /> */}
                    <SearchMultiple<TaskType>
                        include={[tracking.task]}
                        keyName="search_tasks"
                        name="task"
                        max={1}
                        optionsCallback={(r) => ({
                            text: r.name,
                            element: (
                                <SearchCard name={`${r.name} | ${r.project.name} `} image={null} href={"#"} />
                            ),
                            value: r.id,
                        })}
                        placeholder="Choose a project" />
                     <SearchMultiple<UserType>
                        name="user"
                        max={1}
                        label={"User"}
                        keyName="search_users"
                        include={[tracking.user]}
                        optionsCallback={(r) => ({
                            text: r.name,
                            element: (
                                <SearchCard name={`${r.name}`} image={null} href={"#"} />
                            ),
                            value: r.id,
                        })} />
                    <DateTimeInput label="Start" name="created_at" />
                    <DateTimeInput label="End" name="end_date" />
                    <Submit className='w-full' value="Save" />

                </Form>
            </div>
        </Layout>
    )
}

export default Edit
